<template>

  <v-bottom-navigation app grow class="d-sm-none" shift background-color="#fff">
    <v-btn v-for="link in bottomNav" :key="link.title" :to="{ name: link.route }" color="var(--purple)" icon>
      <span class="text-capitalize">{{ link.title }}</span>
      <v-icon>{{ link.icon }}</v-icon>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
export default {};
</script>

<style>
</style>


<script>
import store from "@/store";
export default {
  name: "Navigation",
  components: {},
  data() {
    return {
      active: 1,
      bottomNav: [
          {
            title: "Home",
            icon: "mdi-home-variant-outline",
            route: "dashboard"
          },
          {
            title: "Bookmarks",
            icon: "mdi-heart-outline",
            route: "bookmarks"
          },
          {
            title: "Settings",
            icon: "mdi-cog-outline",
            route: "settings"
          },
          {
            title: "Profile",
            icon: "mdi-account-circle",
            route: "profile"
          }],
     
    };
  },
  computed: {
    current_user: () => store.getters["auth/user"],
    userId() {
      const { user_id, username } = this.current_user;
      //if the username has not been set, use  truncated user_id as router params
      const current_user_id = username ? username : user_id;
      return current_user_id;
    },
  },
};
</script> 